<template>
  <div id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<script>
const defaultLayout = "default";

export default {
  name: "App",
  computed: {
    layout() {
      return `${this.$route.meta.layout || defaultLayout}-layout`
    }
  }
};
</script>

<style lang="scss">
  @import "./assets/bootstrap-custom.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue